import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading } from '../../components';
import IconCard from '../../components/SavedCardDetails/IconCard/IconCard';
import css from './SectionVerificationDocsMaybe.module.css';

const SectionVerificationDocsMaybe = props => {
  const { isOwnListing = false, listing = null } = props;

  if (!isOwnListing || !listing) {
    return null;
  }

  const { privateData } = listing.attributes || {};
  const doc1 = privateData?.verificationDocument1 || privateData?.verificationDocuments?.[0];
  const doc2 = privateData?.verificationDocument2 || privateData?.verificationDocuments?.[1];
  const doc3 = privateData?.verificationDocument3 || privateData?.verificationDocuments?.[2];

  const verificationDocs = [doc1, doc2, doc3].filter(url => !!url);

  if (verificationDocs.length === 0) {
    return null;
  }

  return (
    <section className={css.sectionVerification} id="listing-verification-docs">
      <div className={css.headingWrapper}>
        <Heading as="h2" rootClassName={css.sectionHeading}>
          <FormattedMessage id="ListingPage.verificationDocsTitle" />
        </Heading>
        <span className={css.badge}>
          <FormattedMessage id="ListingPage.verificationDocsPrivateBadge" />
        </span>
      </div>
      <p className={css.tip}>
        <FormattedMessage id="ListingPage.verificationDocsTip" />
      </p>

      <div className={css.documentGrid}>
        {verificationDocs.map((url, idx) => {
          const filename = url.split('/').pop();

          return (
            <a
              key={url}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className={css.documentCard}
              title="View document"
            >
              <div className={css.thumbnailWrapper}>
                {url.match(/\.(jpeg|jpg|gif|png|webp)/i) ? (
                  <img
                    src={url}
                    alt={`Verification document ${idx + 1}`}
                    className={css.thumbnail}
                  />
                ) : (
                  <IconCard className={css.docIcon} />
                )}
              </div>
              <div className={css.fileName}>{filename}</div>
            </a>
          );
        })}
      </div>
    </section>
  );
};

SectionVerificationDocsMaybe.propTypes = {
  isOwnListing: PropTypes.bool,
  listing: PropTypes.object,
};

export default SectionVerificationDocsMaybe;
